import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { ICouponCode, ICouponCodeInitialState } from "./couponcodeModel";
import {
  createCouponCode,
  deleteCouponCode,
  getAllActiveCouponCode,
  getAllCouponCodes,
  getCouponCodeById,
  couponcodeActiveInactive,
  updateCouponCode,
  couponcodeImageUpload,
} from "./services/couponcode.services";

const initialState: ICouponCodeInitialState = {
  loading: false,
  formLoading: false,
  error: "",
  CouponCodeList: [],
  CouponCodeID: null,
  CouponCodeDetail: {
    CouponCode: "",
    FromDate: "",
    ToDate: "",
    DestinationID: null,
    UsageCount: null,
    AmountType: "",
    Percentage: null,
    Amount: null,
    MaxAmount: null,
    IsActive: 1,
  },
};

const couponcodeSlice = createSlice({
  name: "couponcode",
  initialState,
  reducers: {
    clearCouponCodeDetails: (state) => {
      state.CouponCodeDetail = initialState.CouponCodeDetail;
    },
    setCouponCodeID: (state, action) => {
      state.CouponCodeID = action.payload;
    },
    clearCouponCodeID: (state) => {
      state.CouponCodeID = initialState.CouponCodeID;
    },
  },
  extraReducers: (builder) => {
    /* For getAll Cities */
    builder.addCase(getAllCouponCodes.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllCouponCodes.fulfilled,
      (state, action: PayloadAction<ICouponCode[]>) => {
        state.loading = false;
        state.CouponCodeList = action.payload || [];
      }
    );
    builder.addCase(getAllCouponCodes.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CouponCodeList = [];
    });

    /* For getCouponCodeBy ID */
    builder.addCase(getCouponCodeById.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(getCouponCodeById.fulfilled, (state, action: any) => {
      state.formLoading = false;
      state.CouponCodeDetail = action.payload;
    });
    builder.addCase(getCouponCodeById.rejected, (state, action) => {
      state.formLoading = false;
      state.CouponCodeDetail = initialState.CouponCodeDetail;
      state.error = action.error.message || "Something went wrong";
    });

    /* For create CouponCode */
    builder.addCase(createCouponCode.pending, (state) => {
      state.formLoading = false;
      state.error = "";
    });
    builder.addCase(createCouponCode.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(createCouponCode.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For Update CouponCode */
    builder.addCase(updateCouponCode.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(updateCouponCode.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(updateCouponCode.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For Delete Cities */
    builder.addCase(deleteCouponCode.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(deleteCouponCode.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(deleteCouponCode.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For CouponCodeActiveInactive */
    builder.addCase(couponcodeActiveInactive.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(couponcodeActiveInactive.fulfilled, (state) => {
      state.loading = false;
    });
    builder.addCase(couponcodeActiveInactive.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
    });

    /* For FindAllActiveStates */
    builder.addCase(getAllActiveCouponCode.pending, (state) => {
      state.loading = true;
      state.error = "";
    });
    builder.addCase(
      getAllActiveCouponCode.fulfilled,
      (state, action: PayloadAction<ICouponCode[]>) => {
        state.loading = false;
        state.CouponCodeList = action.payload || [];
      }
    );
    builder.addCase(getAllActiveCouponCode.rejected, (state, action) => {
      state.loading = false;
      state.error = action.error.message || "Something went wrong";
      state.CouponCodeList = [];
    });

    /* For Update CouponCode Image */
    builder.addCase(couponcodeImageUpload.pending, (state) => {
      state.formLoading = true;
      state.error = "";
    });
    builder.addCase(couponcodeImageUpload.fulfilled, (state) => {
      state.formLoading = false;
    });
    builder.addCase(couponcodeImageUpload.rejected, (state, action) => {
      state.formLoading = false;
      state.error = action.error.message || "Something went wrong";
    });
  },
});

export const { clearCouponCodeID, clearCouponCodeDetails, setCouponCodeID } =
  couponcodeSlice.actions;
export default couponcodeSlice.reducer;
